import {Injectable} from '@angular/core';
import {
  DelegoRapidPayThreeDSecureInfoWithDelegoToken
} from '../../../../model/delego-rapidpay/delego-rapidpay-authenticate';
import {DelegoRapidPayThreeDSecureStatus} from '../../../../model/delego-rapidpay/delego-rapidpay.enum';
import {
  DelegoAuthenticationValidation
} from '@app/payment/services/delego-rapidpay/validation/delego-athentication-validations.model';


export const defaultDelegoAuthenticationValidStatuses: DelegoRapidPayThreeDSecureStatus[] = [
  DelegoRapidPayThreeDSecureStatus.Success, DelegoRapidPayThreeDSecureStatus.SuccessfulAttempts
];

@Injectable({
  providedIn: 'root'
})
export class DefaultDelegoAuthenticationValidationService implements DelegoAuthenticationValidation {

  isValid(authResponse: DelegoRapidPayThreeDSecureInfoWithDelegoToken): boolean {
    return defaultDelegoAuthenticationValidStatuses.includes(authResponse?.status);
  }
}
